var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.5C4.33332 8.5 3.5 7.66668 3.5 6C3.5 4.33332 4.33332 3.5 6 3.5C7.66668 3.5 8.5 4.33332 8.5 6C8.5 7.66668 7.66668 8.5 6 8.5ZM3.53125 3.53125C3.09375 3.96875 2.80208 4.45833 2.65625 5H0V1.5C0 1.0625 0.145832 0.708335 0.4375 0.4375C0.770835 0.145832 1.13541 0 1.53125 0H10.5312C10.9271 0 11.2708 0.145832 11.5625 0.4375C11.8542 0.729168 12 1.08333 12 1.5V5H9.375C9.22917 4.45833 8.9375 3.96875 8.5 3.53125C7.8125 2.84375 6.97917 2.5 6 2.5C5.04166 2.5 4.21875 2.84375 3.53125 3.53125ZM11 2.625V1.40625C11 1.30208 10.9583 1.20833 10.875 1.125C10.7917 1.04167 10.6979 1 10.5938 1H9.40625C9.30208 1 9.20833 1.04167 9.125 1.125C9.04167 1.20833 9 1.30208 9 1.40625V2.625C9 2.72917 9.04167 2.82292 9.125 2.90625C9.1875 2.96875 9.28125 3 9.40625 3H10.5938C10.7188 3 10.8125 2.96875 10.875 2.90625C10.9583 2.82292 11 2.72917 11 2.625ZM8.5 8.46875C9.16667 7.80208 9.5 6.97917 9.5 6H12V10.5C12 10.875 11.8542 11.2292 11.5625 11.5625C11.2917 11.8542 10.9479 12 10.5312 12H1.53125C1.11458 12 0.760418 11.8542 0.46875 11.5625C0.156248 11.25 0 10.8958 0 10.5V6H2.53125C2.53125 6.97917 2.86458 7.80208 3.53125 8.46875C4.21875 9.15625 5.04166 9.5 6 9.5C6.97917 9.5 7.8125 9.15625 8.5 8.46875Z",
    fill: "#8D8B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.9b7d61808167a68992370ae18619dbc2.svg";
export { ForwardRef as ReactComponent };